const COMMON_CONFIG = {
  game_code: 'elven_princesses',
  player_currency: 'USD',
  included_types: ['TOURNAMENT'],
  included_statuses: ['RUNNING', 'COMING_SOON', 'ENDED'],
  lang: 'EN',
  locale: 'en-US',
};

export const CONFIG = {
  local: {
    ...COMMON_CONFIG,
    operator_code: 'gt_1124',
    game_url: 'https://api-kube.gt.evoent.tech/testing-tool/api/v1/launch-game',
  },
  stage: {
    ...COMMON_CONFIG,
    operator_code: 'gt_1124',
    game_url: 'https://api-kube.gt.evoent.tech/testing-tool/api/v1/launch-game',
  },
  prod: {
    ...COMMON_CONFIG,
    operator_code: 'eu_10077',
    game_url: 'https://api-kube.evoplay.games/testing-tool/api/v1/launch-game',
  },
};
